import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { node, oneOfType, string } from 'prop-types';

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.5)',
    fontSize: 12,
    fontFamily: '"Open Sans", sans-serif !important',
    '& .tooltipText': {
      fontWeight: '400',
    },
  },
  arrow: {
    color: theme.palette.common.white,
  },
}))(Tooltip);

export default function MuiLightTooltip({ title, children, ...props }) {
  return (
    <LightTooltip
      title={<span className="tooltipText">{title}</span>}
      placement="bottom-start"
      {...props}
    >
      {children}
    </LightTooltip>
  );
}

MuiLightTooltip.propTypes = {
  title: oneOfType([string, node]),
  children: node,
};
